import { all, put, take } from 'redux-saga/effects';
import { queryClient } from '~/main';
import * as actions from '../actions';
import { forceReplace } from '../browserHistory';
import { apiMethodsConst } from '../services/methods';
import { callAndDispatch } from './utils';

export function* watchOfficeSelect() {
  const events = actions.createRequestTypes(actions.SELECT_OFFICE);
  while (true) {
    const { officeId, redirectUrl = '/' } = yield take(actions.SELECT_OFFICE);
    forceReplace(redirectUrl);
    queryClient.clear();
    yield put({ type: events.REQUEST, payload: officeId });
    if (officeId) {
      localStorage.setItem('selectedOfficeId', officeId);
    } else {
      localStorage.removeItem('selectedOfficeId');
    }

    try {
      yield all([
        callAndDispatch(apiMethodsConst.GET_SELECTED_OFFICE_PROFILE_REQUEST),
        callAndDispatch(apiMethodsConst.USER_CREDENTIALS_REQUEST),
        callAndDispatch(apiMethodsConst.GET_STATE_WORKER_CLASSIFICATION_REQUEST),
      ]);
      yield put({ type: events.SUCCESS });
    } catch (error) {
      // GOTU-4961: under flag ON, /office is REQUIRED (the real cutover), so a /office outage
      // now rejects the office read. Without this catch that rejection would terminate
      // watchOfficeSelect and kill ALL subsequent office switching until a full reload. Emit
      // FAILURE so the loading selector clears and the saga survives to handle the next switch.
      yield put({ type: events.FAILURE, payload: error?.response?.data ?? error });
    }
  }
}

export function* watcSearchChildOffice() {
  while (true) {
    const events = actions.createRequestTypes(actions.SEARCH_OFFICE_ACTION);
    const { searchText } = yield take(actions.SEARCH_OFFICE_ACTION);
    yield put({ type: events.SUCCESS, payload: searchText });
  }
}

export function* watchGetChildOffices() {
  const events = actions.createRequestTypes(actions.GET_CHILD_OFFICES_ACTION);
  while (true) {
    yield take(actions.GET_CHILD_OFFICES_ACTION);
    yield put({ type: events.REQUEST });
    try {
      yield* callAndDispatch(apiMethodsConst.GET_CHILD_OFFICES_REQUEST);

      yield put({ type: events.SUCCESS });
    } catch (error) {
      yield put({ type: events.FAILURE, payload: error.response.data });
    }
  }
}

